import { useEffect } from "react";
import { DataTableProvider } from "../../context/DataTableContext";
import DataTableWrapper from "./DataTableWrapper";
export const DATA_TABLE_TYPES = {
    YES_OR_NO_ICON: 1,
    DATE_TIME: 2,
    DATE: 3,
    TIME: 4,
    REPORT_DATE: 5,
    PRICE: 6
}

export default function DataTable({children, columns, customRender, customFilters, ...dataTable}){
    const newCustomFilters = customFilters && customFilters.map(custom => { return { ...custom, hidden: true} });
    return (
        <DataTableProvider defaultColumns={columns} customFilters={newCustomFilters} {...dataTable}>
            <DataTableWrapper customRender={customRender}>
                {children}
            </DataTableWrapper>
        </DataTableProvider>
    )
}